/* eslint-disable @next/next/no-img-element */
import React, { FC } from "react";
import { ItemSubDetails } from "@pepdirect/ui/cart/ItemSubDetails";
import { ItemImage } from "@pepdirect/ui/cart/ItemImage";
import { Subtotal } from "@pepdirect/ui/cart/Subtotal";
import { ItemPrice } from "@pepdirect/ui/cart/ItemPrice";
import { ItemTitle } from "@pepdirect/ui/cart/ItemTitle";
import { ItemCustomizations } from "@pepdirect/ui/cart/ItemCustomizations";
import { SubmittedOrderForOrderConfirmationQuery } from "services/graphql/generated";
import st from "./orderItem.module.scss";

export interface OrderItemProps {
  priceItem?: NonNullable<
    SubmittedOrderForOrderConfirmationQuery["submittedOrder"]
  >["price"]["items"][number];
}

/**
 * matches libs/ui/src/lib/components/cart/CartItem.tsx but
 * uses priceItem instead of cartItem and has no actions
 */
export const OrderItem: FC<OrderItemProps> = ({ priceItem }) => {
  const { item, quantity, subscriptionIntervalInDays, customizations } =
    priceItem || {};

  if (!priceItem || !item) return null;

  const { title, price, compareAtPrice, imgUrl, subscriptionMetadata } = item;
  const calculatedPrice = subscriptionIntervalInDays
    ? subscriptionMetadata?.subscriptionPrice
    : price;
  const calculatedCompareAtPrice = subscriptionIntervalInDays
    ? subscriptionMetadata?.subscriptionPrice
    : compareAtPrice;
  return (
    <div className={st.orderItem} data-testid="order-item">
      <ItemImage
        itemImgSrc={imgUrl || ""}
        productTitle={title || "order item"}
        small
      />

      <div className={st.details}>
        <ItemTitle productTitle={title || "order item"} small />

        <ItemPrice
          compareAtPrice={calculatedCompareAtPrice}
          price={price}
          subscriptionPrice={
            subscriptionIntervalInDays &&
            subscriptionMetadata?.subscriptionPrice
          }
          small
        />

        <div className={st.qty}>Qty: {quantity}</div>

        {customizations && (
          <ItemCustomizations customizations={customizations} />
        )}

        {subscriptionIntervalInDays && (
          <ItemSubDetails
            subscribed={!!subscriptionIntervalInDays}
            interval={subscriptionIntervalInDays}
          />
        )}
      </div>

      {price && quantity && (
        <Subtotal price={calculatedPrice || 0} quantity={quantity} small />
      )}
    </div>
  );
};
